// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perEA6 {
  width: 100%;
  overflow-y: auto;
  max-height: 600px;
}

.perEA6.KtewGj {
  max-height: none;
  overflow: visible;
  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);
}

.KtewGj .HXPpsl {
  border-radius: 0;
  overflow: visible;
}

.KtewGj .Jf49op {
  padding: 0;
  margin-bottom: 8px;
  height: 21px;
}

.KtewGj .mMMVq3 {
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  color: var(--text-neutral-dark, #1f1f1f);
}

.KtewGj .ulO34H {
  gap: 8px;
}

.KtewGj .BnINaq {
  box-sizing: border-box;
  height: 82px;
  padding: 16px;
  gap: 16px;
  margin: 0;
  border-radius: 4px;
  justify-content: flex-start;
  background-color: var(--surface-neutral-pale, #fafafa);
}

.KtewGj .VITVoQ {
  width: 32px;
  height: 32px;
  margin: 0;
  border-radius: 16px;
  background-color: var(--surface-neutral-white, #fff);
}

.eIM5u7 {
  display: block;
  flex-shrink: 0;
  transform: scale(1.25);
}

.lLR7Cg {
  display: flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
}

.KtewGj .kBMSaP {
  margin: 0;
  height: 20px;
  flex-shrink: 0;
  line-height: 0;
}

.KtewGj .quzMuy {
  display: flex;
  flex-direction: column;
  height: 61px;
}

.KtewGj .kyokyS {
  height: 22px;
  flex-shrink: 0;
  line-height: 0;
}

.KtewGj .gwH8Zr {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--text-neutral-dark, #1f1f1f);
}

.KtewGj .BKVIwa {
  display: block;
  height: 19px;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
  color: var(--text-neutral-dark, #1f1f1f);
}

.KtewGj .gVlaCE {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.6;
  color: var(--text-neutral-dark, #1f1f1f);
}

.KtewGj .QAj4j2,
.KtewGj .cw97JL {
  margin: 0;
}

.KtewGj .hrcCa7 .VITVoQ {
  background-color: transparent;
}

.KtewGj .hrcCa7 .eIM5u7 {
  opacity: 0.5;
}

.KtewGj .hrcCa7 .gwH8Zr,
.KtewGj .hrcCa7 .gVlaCE {
  color: #999;
}

.KtewGj .hrcCa7 .gwH8Zr {
  font-weight: 600;
  line-height: 1.8;
}

.KtewGj .hrcCa7 .kBMSaP {
  height: 25px;
}

.KtewGj .hrcCa7 .quzMuy {
  height: 66px;
}

.AHlW2H {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.KFQToO {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
}

.WFHD05 {
  margin-top: 16px;
  color: var(--color-text-secondary, #6c757d);
  font-size: 14px;
}

/* Empty State */
.b2wbfJ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
}

.uwhe3p {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: var(--color-background-secondary, #f8f9fa);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.zIjX9S {
  width: 32px;
  height: 32px;
  color: var(--color-text-secondary, #6c757d);
}

.yIzZuL {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text-primary, #212529);
  margin: 0 0 8px 0;
}

.HaZQD5 {
  font-size: 14px;
  color: var(--color-text-secondary, #6c757d);
  margin: 0;
  line-height: 1.5;
}

.HXPpsl {
  background-color: var(--color-background-primary, #ffffff);
  border-radius: 12px;
  overflow: hidden;
}

.Jf49op {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
}

.mMMVq3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text-primary, #212529);
  margin: 0;
}

.ODbTM5 {
  font-size: 12px;
  color: var(--color-text-secondary, #6c757d);
  background-color: var(--color-background-tertiary, #e9ecef);
  padding: 4px 8px;
  border-radius: 8px;
}

.ulO34H {
  display: flex;
  flex-direction: column;
}

.BnINaq {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  text-decoration: none;
  color: inherit;
  background-color: var(--surface-neutral-pale);
  margin-bottom: 8px;
  justify-content: center;
}

.hrcCa7 {
  color: var(--text-neutral-strong);
}

.hrcCa7 .JsYid1 {
  filter: brightness(0) saturate(100%) invert(23%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(92%);
  color: var(--text-neutral-strong) !important;
  opacity: 0.7;
}
.hrcCa7 .gwH8Zr {
  color: var(--text-neutral-strong);
  text-decoration: line-through;
}
.hrcCa7 .gVlaCE {
  color: var(--text-neutral-strong);
}
.hrcCa7 .D9FYME {
  filter: brightness(0) saturate(100%) invert(23%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(92%);
  color: var(--text-neutral-strong);
  opacity: 0.5;
}

.hrcCa7 .kyokyS,
.hrcCa7 .kBMSaP {
  color: var(--text-neutral-strong);
}

.BnINaq:last-child {
  border-bottom: none;
}

.BnINaq:hover {
  background-color: var(--color-background-hover, rgba(255, 102, 0, 0.05));
}

.BnINaq:focus {
  background-color: var(--color-background-hover, rgba(255, 102, 0, 0.05));
}

.MUy0kL {
  cursor: default;
}

.MUy0kL:hover,
.MUy0kL:focus {
  background-color: var(--surface-neutral-pale);
}

.VITVoQ {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--color-background-secondary, #ffffff);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  flex-shrink: 0;
}

.JsYid1 {
  width: 20px;
  height: 20px;
  filter: brightness(0) saturate(100%) invert(23%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(92%);
}

.quzMuy {
  flex: 1;
  min-width: 0;
}

.kBMSaP {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.gwH8Zr {
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-primary, #212529);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gVlaCE {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary, #212529);
  margin-left: 16px;
  flex-shrink: 0;
}

.kyokyS {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.BKVIwa {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-sm-font-size, 12px);
  font-weight: var(--font-weight-regular, 400);
  line-height: 160%;
  color: var(--text-neutral-dark, #1f1f1f);
}

.QAj4j2 {
  margin-left: 16px;
  flex-shrink: 0;
}

.D9FYME {
  width: 16px;
  height: 16px;
  color: var(--color-text-secondary, #6c757d);
  transition: transform 0.2s ease-in-out;
}

.BnINaq:hover .D9FYME {
  transform: translateX(4px);
  color: var(--color-primary, #ff6600);
}

.cw97JL {
  margin-left: var(--spacing-2);
  flex-shrink: 0;
}

/* Load More */
.oZfASE {
  padding: 20px;
  display: flex;
  justify-content: center;
}

.EMfxkq {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cbn4XM {
  font-size: 14px;
  color: var(--color-text-secondary, #6c757d);
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .perEA6 {
    max-height: 70vh;
  }

  .Jf49op {
    padding: 12px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .mMMVq3 {
    font-size: 15px;
  }

  .ODbTM5 {
    align-self: flex-end;
  }

  .BnINaq {
    padding: 12px 16px;
  }

  .VITVoQ {
    width: 36px;
    height: 36px;
    margin-right: 12px;
  }

  .JsYid1 {
    width: 18px;
    height: 18px;
  }

  .kBMSaP {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    margin-bottom: 6px;
  }

  .gVlaCE {
    margin-left: 0;
    align-self: flex-end;
  }

  .kyokyS {
    flex-wrap: wrap;
    gap: 8px;
  }

  .b2wbfJ,
  .KFQToO {
    padding: 32px 16px;
  }

  .uwhe3p {
    width: 56px;
    height: 56px;
    margin-bottom: 20px;
  }

  .zIjX9S {
    width: 28px;
    height: 28px;
  }
}

/* Small Mobile */
@media (max-width: 480px) {
  .kBMSaP {
    margin-bottom: 4px;
  }

  .gwH8Zr {
    font-size: 13px;
  }

  .gVlaCE {
    font-size: 13px;
  }

  .BKVIwa {
    font-size: 11px;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .BnINaq,
  .D9FYME {
    transition: none;
  }

  .BnINaq:hover .D9FYME {
    transform: none;
  }
}

/* High contrast mode */
@media (prefers-contrast: high) {
  .HXPpsl {
    border-width: 2px;
  }

  .BnINaq {
    border-bottom-width: 2px;
  }

  .BnINaq:focus {
    outline-width: 3px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/RechargeHistoryList/RechargeHistoryList.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wEAAwE;AAC1E;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4DAA4D;EAC5D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,2DAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,6CAA6C;EAC7C,qBAAqB;EACrB,cAAc;EACd,6CAA6C;EAC7C,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sHAAsH;EACtH,4CAA4C;EAC5C,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,sHAAsH;EACtH,iCAAiC;EACjC,YAAY;AACd;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4DAA4D;EAC5D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sHAAsH;AACxH;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,mDAAmD;EACnD,4CAA4C;EAC5C,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".container {\n  width: 100%;\n  overflow-y: auto;\n  max-height: 600px;\n}\n\n.container.migrationHistory {\n  max-height: none;\n  overflow: visible;\n  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);\n}\n\n.migrationHistory .competenceGroup {\n  border-radius: 0;\n  overflow: visible;\n}\n\n.migrationHistory .competenceHeader {\n  padding: 0;\n  margin-bottom: 8px;\n  height: 21px;\n}\n\n.migrationHistory .competenceTitle {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 21px;\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.migrationHistory .rechargesList {\n  gap: 8px;\n}\n\n.migrationHistory .rechargeItem {\n  box-sizing: border-box;\n  height: 82px;\n  padding: 16px;\n  gap: 16px;\n  margin: 0;\n  border-radius: 4px;\n  justify-content: flex-start;\n  background-color: var(--surface-neutral-pale, #fafafa);\n}\n\n.migrationHistory .rechargeIcon {\n  width: 32px;\n  height: 32px;\n  margin: 0;\n  border-radius: 16px;\n  background-color: var(--surface-neutral-white, #fff);\n}\n\n.migrationRepeatIcon {\n  display: block;\n  flex-shrink: 0;\n  transform: scale(1.25);\n}\n\n.migrationRepeatSlot {\n  display: flex;\n  width: 20px;\n  height: 20px;\n  align-items: center;\n  justify-content: center;\n}\n\n.migrationHistory .rechargeHeader {\n  margin: 0;\n  height: 20px;\n  flex-shrink: 0;\n  line-height: 0;\n}\n\n.migrationHistory .rechargeInfo {\n  display: flex;\n  flex-direction: column;\n  height: 61px;\n}\n\n.migrationHistory .rechargeFooter {\n  height: 22px;\n  flex-shrink: 0;\n  line-height: 0;\n}\n\n.migrationHistory .rechargeProtocol {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.migrationHistory .rechargeDate {\n  display: block;\n  height: 19px;\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.6;\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.migrationHistory .rechargeAmount {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.6;\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.migrationHistory .rechargeArrow,\n.migrationHistory .rechargeOptions {\n  margin: 0;\n}\n\n.migrationHistory .rechargeItemCancelled .rechargeIcon {\n  background-color: transparent;\n}\n\n.migrationHistory .rechargeItemCancelled .migrationRepeatIcon {\n  opacity: 0.5;\n}\n\n.migrationHistory .rechargeItemCancelled .rechargeProtocol,\n.migrationHistory .rechargeItemCancelled .rechargeAmount {\n  color: #999;\n}\n\n.migrationHistory .rechargeItemCancelled .rechargeProtocol {\n  font-weight: 600;\n  line-height: 1.8;\n}\n\n.migrationHistory .rechargeItemCancelled .rechargeHeader {\n  height: 25px;\n}\n\n.migrationHistory .rechargeItemCancelled .rechargeInfo {\n  height: 66px;\n}\n\n.listContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.loadingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n}\n\n.loadingText {\n  margin-top: 16px;\n  color: var(--color-text-secondary, #6c757d);\n  font-size: 14px;\n}\n\n/* Empty State */\n.emptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n}\n\n.emptyIcon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background-color: var(--color-background-secondary, #f8f9fa);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n}\n\n.emptyIconInner {\n  width: 32px;\n  height: 32px;\n  color: var(--color-text-secondary, #6c757d);\n}\n\n.emptyTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-text-primary, #212529);\n  margin: 0 0 8px 0;\n}\n\n.emptyDescription {\n  font-size: 14px;\n  color: var(--color-text-secondary, #6c757d);\n  margin: 0;\n  line-height: 1.5;\n}\n\n.competenceGroup {\n  background-color: var(--color-background-primary, #ffffff);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.competenceHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n}\n\n.competenceTitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--color-text-primary, #212529);\n  margin: 0;\n}\n\n.competenceCount {\n  font-size: 12px;\n  color: var(--color-text-secondary, #6c757d);\n  background-color: var(--color-background-tertiary, #e9ecef);\n  padding: 4px 8px;\n  border-radius: 8px;\n}\n\n.rechargesList {\n  display: flex;\n  flex-direction: column;\n}\n\n.rechargeItem {\n  display: flex;\n  align-items: center;\n  padding: 16px 20px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  text-decoration: none;\n  color: inherit;\n  background-color: var(--surface-neutral-pale);\n  margin-bottom: 8px;\n  justify-content: center;\n}\n\n.rechargeItemCancelled {\n  color: var(--text-neutral-strong);\n}\n\n.rechargeItemCancelled .rechargeIconInner {\n  filter: brightness(0) saturate(100%) invert(23%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(92%);\n  color: var(--text-neutral-strong) !important;\n  opacity: 0.7;\n}\n.rechargeItemCancelled .rechargeProtocol {\n  color: var(--text-neutral-strong);\n  text-decoration: line-through;\n}\n.rechargeItemCancelled .rechargeAmount {\n  color: var(--text-neutral-strong);\n}\n.rechargeItemCancelled .arrowIcon {\n  filter: brightness(0) saturate(100%) invert(23%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(92%);\n  color: var(--text-neutral-strong);\n  opacity: 0.5;\n}\n\n.rechargeItemCancelled .rechargeFooter,\n.rechargeItemCancelled .rechargeHeader {\n  color: var(--text-neutral-strong);\n}\n\n.rechargeItem:last-child {\n  border-bottom: none;\n}\n\n.rechargeItem:hover {\n  background-color: var(--color-background-hover, rgba(255, 102, 0, 0.05));\n}\n\n.rechargeItem:focus {\n  background-color: var(--color-background-hover, rgba(255, 102, 0, 0.05));\n}\n\n.rechargeItemActionsViaMenu {\n  cursor: default;\n}\n\n.rechargeItemActionsViaMenu:hover,\n.rechargeItemActionsViaMenu:focus {\n  background-color: var(--surface-neutral-pale);\n}\n\n.rechargeIcon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: var(--color-background-secondary, #ffffff);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 16px;\n  flex-shrink: 0;\n}\n\n.rechargeIconInner {\n  width: 20px;\n  height: 20px;\n  filter: brightness(0) saturate(100%) invert(23%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(92%);\n}\n\n.rechargeInfo {\n  flex: 1;\n  min-width: 0;\n}\n\n.rechargeHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.rechargeProtocol {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--color-text-primary, #212529);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rechargeAmount {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary, #212529);\n  margin-left: 16px;\n  flex-shrink: 0;\n}\n\n.rechargeFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.rechargeDate {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-sm-font-size, 12px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 160%;\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.rechargeArrow {\n  margin-left: 16px;\n  flex-shrink: 0;\n}\n\n.arrowIcon {\n  width: 16px;\n  height: 16px;\n  color: var(--color-text-secondary, #6c757d);\n  transition: transform 0.2s ease-in-out;\n}\n\n.rechargeItem:hover .arrowIcon {\n  transform: translateX(4px);\n  color: var(--color-primary, #ff6600);\n}\n\n.rechargeOptions {\n  margin-left: var(--spacing-2);\n  flex-shrink: 0;\n}\n\n/* Load More */\n.loadMoreTrigger {\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n}\n\n.loadMoreIndicator {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.loadMoreText {\n  font-size: 14px;\n  color: var(--color-text-secondary, #6c757d);\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .container {\n    max-height: 70vh;\n  }\n\n  .competenceHeader {\n    padding: 12px 16px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .competenceTitle {\n    font-size: 15px;\n  }\n\n  .competenceCount {\n    align-self: flex-end;\n  }\n\n  .rechargeItem {\n    padding: 12px 16px;\n  }\n\n  .rechargeIcon {\n    width: 36px;\n    height: 36px;\n    margin-right: 12px;\n  }\n\n  .rechargeIconInner {\n    width: 18px;\n    height: 18px;\n  }\n\n  .rechargeHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    margin-bottom: 6px;\n  }\n\n  .rechargeAmount {\n    margin-left: 0;\n    align-self: flex-end;\n  }\n\n  .rechargeFooter {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .emptyState,\n  .loadingContainer {\n    padding: 32px 16px;\n  }\n\n  .emptyIcon {\n    width: 56px;\n    height: 56px;\n    margin-bottom: 20px;\n  }\n\n  .emptyIconInner {\n    width: 28px;\n    height: 28px;\n  }\n}\n\n/* Small Mobile */\n@media (max-width: 480px) {\n  .rechargeHeader {\n    margin-bottom: 4px;\n  }\n\n  .rechargeProtocol {\n    font-size: 13px;\n  }\n\n  .rechargeAmount {\n    font-size: 13px;\n  }\n\n  .rechargeDate {\n    font-size: 11px;\n  }\n}\n\n/* Accessibility */\n@media (prefers-reduced-motion: reduce) {\n  .rechargeItem,\n  .arrowIcon {\n    transition: none;\n  }\n\n  .rechargeItem:hover .arrowIcon {\n    transform: none;\n  }\n}\n\n/* High contrast mode */\n@media (prefers-contrast: high) {\n  .competenceGroup {\n    border-width: 2px;\n  }\n\n  .rechargeItem {\n    border-bottom-width: 2px;\n  }\n\n  .rechargeItem:focus {\n    outline-width: 3px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `perEA6`,
	"migrationHistory": `KtewGj`,
	"competenceGroup": `HXPpsl`,
	"competenceHeader": `Jf49op`,
	"competenceTitle": `mMMVq3`,
	"rechargesList": `ulO34H`,
	"rechargeItem": `BnINaq`,
	"rechargeIcon": `VITVoQ`,
	"migrationRepeatIcon": `eIM5u7`,
	"migrationRepeatSlot": `lLR7Cg`,
	"rechargeHeader": `kBMSaP`,
	"rechargeInfo": `quzMuy`,
	"rechargeFooter": `kyokyS`,
	"rechargeProtocol": `gwH8Zr`,
	"rechargeDate": `BKVIwa`,
	"rechargeAmount": `gVlaCE`,
	"rechargeArrow": `QAj4j2`,
	"rechargeOptions": `cw97JL`,
	"rechargeItemCancelled": `hrcCa7`,
	"listContainer": `AHlW2H`,
	"loadingContainer": `KFQToO`,
	"loadingText": `WFHD05`,
	"emptyState": `b2wbfJ`,
	"emptyIcon": `uwhe3p`,
	"emptyIconInner": `zIjX9S`,
	"emptyTitle": `yIzZuL`,
	"emptyDescription": `HaZQD5`,
	"competenceCount": `ODbTM5`,
	"rechargeIconInner": `JsYid1`,
	"arrowIcon": `D9FYME`,
	"rechargeItemActionsViaMenu": `MUy0kL`,
	"loadMoreTrigger": `oZfASE`,
	"loadMoreIndicator": `EMfxkq`,
	"loadMoreText": `cbn4XM`
};
module.exports = ___CSS_LOADER_EXPORT___;
